import { MprcContainer, MprcFormBarHeader } from 'components';
import { ButtonBack } from 'components/buttons';
import React from 'react';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    actions?: React.ReactNode[];
    onClose: () => void;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const TrainingViewBar: React.FC<IProps> = (props) => {

    const { actions, onClose } = props;

    var headerItems: React.ReactNode[] = [<ButtonBack rounded size="large" variant="text" onClick={() => onClose()} />];

    if (actions && actions.length > 0)
        headerItems = [...headerItems, ...actions];

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    return (
        <MprcContainer>
            <MprcFormBarHeader actions={headerItems} />
        </MprcContainer>
    );
};
